import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function useGtag(url) {
  const { pathname } = useLocation();

  useEffect(() => {
    if (typeof window.gtag !== 'undefined') {
      window.gtag('config', process.env.REACT_APP_GTM, {
        page_title: pathname,
        page_path: pathname,
      });
    }
  }, [pathname]);

  return pathname;
}

export default useGtag;
